import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import React from "react";
import Helper from "../../Helper";

interface ComponentHeaderProps {
    label: string;
    icon: FontAwesomeIconProps["icon"] | null;
    color: string; // Tailwind CSS color class (e.g., "text-blue-500")
    className?: string;
    onClick?: () => void;
}

const ComponentHeader: React.FC<ComponentHeaderProps> = ({ label, icon, color, className, onClick }) => {
    return (
        <div
            className={Helper.classNames("flex flex-row items-center gap-2", className || "")}
            onClick={() => onClick && onClick()}
        >
            {icon && <FontAwesomeIcon icon={icon} className={color} />}
            <div className="text-lg font-semibold text-gray-900 dark:text-plot-darkmode-white">{label}</div>
        </div>
    );
};

export default ComponentHeader;
